import { useLoading } from '../../../contexts/LoadingContext';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useGetTriggerRule = (triggerGuid?: string, enableLoader?: boolean) => {
    const loading = useLoading();
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-trigger-rule', { triggerGuid }],
        queryFn: async () => {
            if (!triggerGuid) return;

            if (enableLoader) {
                loading.showLoading();
            }

            const response = await zoneApiClient.getTrigger(triggerGuid);
            return response.payload;
        },
        onSettled: enableLoader ? () => loading.hideLoading() : undefined,
        enabled: !!triggerGuid,
        cacheTime: 0,
        staleTime: 0,
    });
};
